/**
 * Branded featured-image presets — pure CSS/SVG, so authors get a polished
 * hero even when they don't upload a photo.
 */
export const FEATURED_PRESETS = [
  {
    id: "goals-teal",
    label: "Goals · Teal",
    // Radial teal glow over near-black, then a subtle grid overlay
    style: {
      background:
        "radial-gradient(120% 80% at 15% 20%, rgba(20,165,165,0.55) 0%, rgba(20,165,165,0.15) 40%, #0A0A0A 75%)",
    },
    accent: "#14A5A5",
    caption: "Goal-based planning",
  },
  {
    id: "protection-pink",
    label: "Protection · Pink",
    style: {
      background:
        "linear-gradient(135deg, #E11A73 0%, #B31761 45%, #16233D 100%)",
    },
    accent: "#FFE4EF",
    caption: "Protecting what you build",
  },
  {
    id: "inflation-noir",
    label: "Inflation · Noir",
    style: {
      background:
        "linear-gradient(180deg, #0A0A0A 0%, #16233D 60%, #14A5A5 140%)",
    },
    accent: "#B9862E",
    caption: "The quiet tax",
  },
  {
    id: "planning-grid",
    label: "Planning · Cream",
    style: {
      background:
        "repeating-linear-gradient(135deg, #F6F4EA 0 22px, #ECEADD 22px 24px)",
    },
    accent: "#16233D",
    caption: "One strategy, two jobs",
    darkText: true,
  },
];

export function getPreset(id) {
  return FEATURED_PRESETS.find((p) => p.id === id) || null;
}
